export interface PharmacyCategory {
  id: string
  name: string
  mobileLabel: string
  icon: string
  color: string
  bgColor: string
  textColor: string
  productCount: number
  subcategories: string[]
  image: string
}

export const pharmacyCategories: PharmacyCategory[] = [
  {
    id: 'medicines',
    name: 'Medicines & Treatments',
    mobileLabel: 'Medicines',
    icon: '💊',
    color: 'from-red-500 to-red-600',
    bgColor: 'bg-red-50',
    textColor: 'text-red-600',
    productCount: 850,
    subcategories: ['Pain Relief', 'Cold & Flu', 'Allergies', 'Digestive Health', 'Sleep Aids'],
    image: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=400&h=400&fit=crop',
  },
  {
    id: 'vitamins',
    name: 'Vitamins & Supplements',
    mobileLabel: 'Vitamins',
    icon: '💪',
    color: 'from-sage to-sage-dark',
    bgColor: 'bg-sage-light',
    textColor: 'text-sage-dark',
    productCount: 650,
    subcategories: ['Multivitamins', 'Vitamin D', 'Omega-3', 'Probiotics', 'Protein Powder'],
    image: 'https://images.unsplash.com/photo-1550572017-4bfa2d5c8f1d?w=400&h=400&fit=crop',
  },
  {
    id: 'medical-devices',
    name: 'Medical Devices',
    mobileLabel: 'Devices',
    icon: '🩺',
    color: 'from-blue-500 to-blue-600',
    bgColor: 'bg-blue-50',
    textColor: 'text-blue-600',
    productCount: 320,
    subcategories: ['Blood Pressure Monitors', 'Glucose Meters', 'Thermometers', 'Nebulizers', 'Pulse Oximeters'],
    image: 'https://images.unsplash.com/photo-1631549916768-4119b2e5f926?w=400&h=400&fit=crop',
  },
  {
    id: 'beauty',
    name: 'Beauty & Skin Care',
    mobileLabel: 'Beauty',
    icon: '✨',
    color: 'from-pink-500 to-pink-600',
    bgColor: 'bg-pink-50',
    textColor: 'text-pink-600',
    productCount: 780,
    subcategories: ['Facial Care', 'Hair Care', 'Body Care', 'Sun Protection', 'Anti-Aging'],
    image: 'https://images.unsplash.com/photo-1556228720-195a672e8a03?w=400&h=400&fit=crop',
  },
  {
    id: 'baby-care',
    name: 'Baby & Mother Care',
    mobileLabel: 'Baby care',
    icon: '👶',
    color: 'from-purple-500 to-purple-600',
    bgColor: 'bg-purple-50',
    textColor: 'text-purple-600',
    productCount: 520,
    subcategories: ['Baby Formula', 'Diapers', 'Baby Food', 'Prenatal Vitamins', 'Nursing Supplies'],
    image: 'https://images.unsplash.com/photo-1515488042361-ee00e0ddd4e4?w=400&h=400&fit=crop',
  },
  {
    id: 'personal-care',
    name: 'Personal Care',
    mobileLabel: 'Personal care',
    icon: '🧴',
    color: 'from-brand to-brand-dark',
    bgColor: 'bg-brand-light',
    textColor: 'text-brand',
    productCount: 430,
    subcategories: ['Oral Care', 'Bath & Shower', 'Deodorants', 'Shaving', 'Hand Care'],
    image: 'https://images.unsplash.com/photo-1556228852-80f59c1bb3cf?w=400&h=400&fit=crop',
  },
  {
    id: 'health-monitoring',
    name: 'Health Monitoring',
    mobileLabel: 'Monitoring',
    icon: '📊',
    color: 'from-indigo-500 to-indigo-600',
    bgColor: 'bg-indigo-50',
    textColor: 'text-indigo-600',
    productCount: 280,
    subcategories: ['Fitness Trackers', 'Smart Scales', 'Heart Rate Monitors', 'Sleep Trackers', 'Health Apps'],
    image: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=400&h=400&fit=crop',
  },
  {
    id: 'herbal',
    name: 'Herbal & Natural',
    mobileLabel: 'Natural',
    icon: '🌿',
    color: 'from-sage to-sage-dark',
    bgColor: 'bg-sage-light',
    textColor: 'text-sage-dark',
    productCount: 390,
    subcategories: ['Green Tea', 'Ginseng', 'Turmeric', 'Essential Oils', 'Herbal Teas'],
    image: 'https://images.unsplash.com/photo-1471864190281-a93a3070b6de?w=400&h=400&fit=crop',
  },
  {
    id: 'first-aid',
    name: 'First Aid & Safety',
    mobileLabel: 'First aid',
    icon: '🚑',
    color: 'from-orange-500 to-orange-600',
    bgColor: 'bg-orange-50',
    textColor: 'text-orange-600',
    productCount: 210,
    subcategories: ['First Aid Kits', 'Bandages', 'Antiseptics', 'Safety Equipment', 'Emergency Supplies'],
    image: 'https://images.unsplash.com/photo-1603398938378-e54eab446dde?w=400&h=400&fit=crop',
  },
]
